import React, { Component } from 'react'
import { BrowserRouter as Router, Route, Link, withRouter } from 'react-router-dom'
import { observer } from 'mobx-react'

class ScrollToTop extends Component {
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0)
      amplitude.logEvent('Change Location', {location: this.props.location})
    }
  }

  render() {
    return this.props.children
  }
}

export default withRouter(ScrollToTop)